import { useContext } from 'react';

import type { IAppPreviewStateContextValue } from './AppPreviewStateContext';
import { AppPreviewStateContext } from './AppPreviewStateContext';

export const useAppPreviewState = (): IAppPreviewStateContextValue =>
  useContext(AppPreviewStateContext);
